import { engagementChangelogs } from "@dashboardApi/apis/changelogs";

import { engagementApiSuppressionLists } from "../engagementApiSuppressionLists";
import { engagementApiSuppressionListsId } from "../engagementApiSuppressionListsId";
import type { AllRouteEndpoints } from "../routeTypes";

export const engagementSegmentsSegmentIdCacheKey = "/engagement/segment_data";
export const engagementSegmentsSegmentIdCacheKeys: AllRouteEndpoints[] = [
  engagementSegmentsSegmentIdCacheKey,
  engagementChangelogs,
  engagementApiSuppressionListsId,
  engagementApiSuppressionLists,
];
